import api from './BaseApi';

export const createSecurityCheckpoint = async (data) => {
    try {
        const response = await api.post('/admin/security-checkpoints', data);
        return response; 
    } catch (error) {
        console.error('Create security checkpoint error:', error);
        return error;
    }
};

export const getSecurityCheckpoints = async (params) => {
    try {
        const response = await api.get('/admin/security-checkpoints', { params });
        return response.data;
    } catch (error) {
        console.error('Get security checkpoints error:', error);
    }
};

export const getSingleSecurityCheckpoint = async (id) => {
    try {
        const response = await api.get(`/admin/security-checkpoints/${id}`);
        return response.data;
    } catch (error) {
        console.error('Get security checkpoint error:', error);
    }
};

export const updateSecurityCheckpoint = async (id, payload) => {
    try {
        const response = await api.put(`/admin/security-checkpoints/${id}`, payload);
        return response;
    } catch (error) {
        console.error('Update security checkpoint error:', error);
        return error;
    }
};

export const deleteSecurityCheckpoint = async (id) => {
    try {
        const response = await api.delete(`/admin/security-checkpoints/${id}`);
        return response.data;
    } catch (error) {
        console.error('Delete security checkpoint error:', error);
        return error;
    }
};

export const getSecurityMetaData = async () => {
    try {
        const response = await api.get('/admin/security-checkpoints/metadata');
        return response.data;
    } catch (error) {
        console.error('Get security checkpoints metadata error:', error);
    }
};

export const getSecurityConcourses = async (airportId) => {
    try {
        const response = await api.get(`/admin/security-checkpoints/concourses/${airportId}`);
        return response.data;
    } catch (error) {
        console.error('Get concourses error:', error);
    }
};